var module = angular.module('octopusApp.library');

module.controller('LifecycleIndexController', function($scope, $location, busy, octopusRepository, octopusClient) {
  var isLoading = $scope.isLoading = busy.create();

  $scope.previews = {};
  isLoading.promise(octopusRepository.Lifecycles.all().then(function(lifecycles){
    isLoading.promise(octopusRepository.Environments.all().then(function(environments){
      $scope.lifecycles = lifecycles;
      $scope.environments = environments;

      _.each($scope.lifecycles, function(lc) {
        isLoading.promise(octopusRepository.Lifecycles.preview(lc).then(function (preview) {
          $scope.previews[lc.Id] = preview;
        }));
      });
    }));
  }));
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/library/lifecycles/controllers/lifecycle_index_controller.js
// module id = 450
// module chunks = 1